import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

export default function RequireAuth() {
  const { authenticated } = useAuth();
  const location = useLocation();

  // While we're still probing for an existing session cookie, render nothing —
  // PageLoader covers the screen. This avoids a welcome-flash for already-auth'd users.
  if (authenticated === null) return null;
  if (authenticated === false) {
    return <Navigate to="/welcome" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
